import type { CustomerOrder } from "@/lib/zenstack/models"
import { API_ROUTES } from "@/routes"

const orderIdParam = "orderId"

export type API_ROUTES_ORDER_RETURN = CustomerOrder | null
export const API_ROUTES_ORDER = {
  get: (orderId: string) => `${API_ROUTES.order}?${orderIdParam}=${orderId}`,
  params: {
    orderId: orderIdParam,
  },
}
